import { NAME } from './constants';
import List from './List.vue';
import { children } from './components';

export const router = {
	path: NAME,
	name: NAME,
	component: List,
	children,
};
